import theme from "utils/themeVars"
const colorPrimary = theme["primary-color"]

const themeV5 = {
  hashed: false,
  cssVar: { key: "pf-var" },
  token: {
    colorPrimary,
    colorInfo: colorPrimary,
    colorSuccess: colorPrimary,
    colorWarning: theme["warning-color"],
    colorError: theme["error-color"],
    colorText: "#000000d9",
    colorTextBase: theme.gray900,
    colorTextSecondary: theme.gray900,
    fontSizeHeading1: 24,
    fontSizeHeading2: 22,
    fontSizeHeading3: 18,
    fontSizeHeading4: 16,
    fontSizeHeading5: 14,
    borderRadius: 4,
    wireframe: false,
    lineHeightHeading1: "1.33333",
    lineHeightHeading2: "1.36366636",
    lineHeightHeading4: "1.5",
    lineHeightHeading3: "1.44444",
    fontFamily: "Figtree, Noto Sans Arabic, sans-serif",
    accentGradient: "linear-gradient(93.35deg, #0091BA 41%, #4DB2CF 71.28%, #55BCDB 100%)",
  },
  components: {
    Icon: {
      algorithm: true,
    },
    Button: {
      borderRadius: 6,
      borderRadiusLG: 6,
      borderRadiusSM: 6,
      primaryShadow: "",
      controlHeightSM: 36,
      controlHeightLG: 44,
      paddingInlineLG: 32,
      paddingInlineSM: 16,
    },
    Layout: {
      headerBg: "#fff",
      bodyBg: "#f6f7fb",
      footerBg: "#fafafa",
      headerColor: "#ffffffe0",
      lightTriggerColor: "#fff",
      siderBg: "#fff",
      triggerBg: "#fff",
      zeroTriggerHeight: 42,
      zeroTriggerWidth: 36,
      headerPadding: "0 30px 0 15px",
    },
    Space: {
      paddingLG: 32,
    },
    Pagination: {
      itemSize: 36,
      itemActiveBg: theme["primary-light"],
      colorBorder: theme.gray300,
    },
    Form: {
      labelColor: theme.gray900,
      labelRequiredMarkColor: theme["error-color"],
      itemMarginBottom: 18,
    },
    Input: {
      controlHeight: 48,
      colorBorder: theme.gray300,
      controlHeightSM: 24,
      controlHeightLG: 40,
      colorTextPlaceholder: theme.gray700,
    },
    Select: {
      colorPrimaryHover: colorPrimary,
      optionSelectedBg: theme["primary-light"],
      optionSelectedColor: colorPrimary,
      controlHeight: 48,
      colorBorder: theme.gray300,
      colorTextPlaceholder: theme.gray700,
      colorFillSecondary: theme["primary-light"],
    },
    Slider: {
      railBg: "rgba(95,100,242,0.2)",
      railHoverBg: "rgba(95,100,242,0.2)",
      trackBg: colorPrimary,
      trackHoverBg: colorPrimary,
      handleColor: colorPrimary,
      handleSize: 16,
    },
    Switch: {
      trackMinWidth: 35,
      trackMinWidthSM: 30,
    },
    Badge: {
      dotSize: 10,
      marginXS: 0,
      paddingXS: 1,
    },
    Card: {
      borderRadiusLG: 4,
      headerHeight: 68,
    },
    Collapse: {
      borderRadiusLG: 4,
      headerPadding: "12px 12px",
    },
    List: {
      itemPadding: "10px 24px",
      itemPaddingSM: "8px 0",
      colorText: "rgba(0,0,0,0.85)",
      colorTextDescription: theme.gray900,
    },
    Segmented: {
      colorText: theme.gray600,
      itemHoverColor: colorPrimary,
      itemSelectedBg: theme["primary-light"],
      itemSelectedColor: colorPrimary,
      trackBg: "rgba(245,245,245,0)",
      itemColor: theme.gray600,
    },
    Statistic: {
      contentFontSize: 16,
    },
    Table: {
      controlItemBgActive: theme["primary-light"],
      headerBg: theme.gray200,
      headerColor: theme.gray900,
      headerSplitColor: theme.gray200,
      padding: 8,
      rowHoverBg: theme.gray300,
      rowSelectedBg: "#f1f7f1",
      rowSelectedHoverBg: "#f1f7f1",
    },
    Tabs: {
      horizontalMargin: "16px 0",
      horizontalItemPadding: "12px 8px",
      horizontalItemPaddingLG: "12px 16px",
      horizontalItemGutter: 16,
      titleFontSizeLG: 14,
      inkBarColor: theme["accent-color"],
      itemActiveColor: theme["accent-color"],
      itemHoverColor: theme["accent-color"],
      itemSelectedColor: theme["accent-color"],
      colorText: "rgba(0,0,0,0.8)",
    },
    Tag: {
      defaultBg: theme.gray150,
      paddingXXS: 8,
      defaultColor: theme.gray150,
      lineHeight: 2,
      lineHeightSM: 1.6,
      colorTextDescription: colorPrimary,
      fontSizeIcon: 16,
    },
    Tooltip: {
      colorBgSpotlight: "#fff",
      colorText: "#000",
      colorTextLightSolid: "#000",
    },
    Tree: {
      nodeSelectedBg: "rgba(230,244,255,0)",
      directoryNodeSelectedBg: colorPrimary,
      colorBorder: theme.gray300,
    },
    Drawer: {
      fontSizeLG: 20,
      lineHeightLG: 1.4,
      footerPaddingBlock: 20,
    },
    Modal: {
      titleFontSize: 18,
      titleLineHeight: 2.15,
      contentPadding: 0,
    },
    Result: {
      titleFontSize: 20,
      subtitleFontSize: 12,
      iconFontSize: 50,
    },
    Typography: {
      colorText: "rgba(0,0,0,0.8)",
      colorTextDescription: theme.gray900,
    },
    Radio: {
      lineHeight: 2,
      controlHeightSM: 30,
    },
    DatePicker: {
      colorBorder: theme.gray300,
      colorTextPlaceholder: theme.gray700,
      controlHeight: 48,
    },
    Upload: {
      colorBorder: theme.gray300,
      colorFillAlter: "#fff",
    },
    Steps: {
      lineWidth: 0.8,
      dotSize: 16,
      dotCurrentSize: 16,
      fontSizeLG: 14,
    },
    InputNumber: {
      controlHeight: 48,
      colorBorder: theme.gray300,
      colorTextPlaceholder: theme.gray700,
    },
    Avatar: {
      colorTextPlaceholder: theme.gray500,
    },
  },
}

export default themeV5
